import { render, staticRenderFns } from "./PromiseButton.vue?vue&type=template&id=5f53f60a&"
import script from "./PromiseButton.vue?vue&type=script&lang=js&"
export * from "./PromiseButton.vue?vue&type=script&lang=js&"
import style0 from "./PromiseButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports